import {HEADERS} from "apisauce";

export const getRefreshedToken = (headers: HEADERS) => {
  const token = headers?.["x-refreshed-jwt"];

  return token ? token.split(" ")[1] : null;
};
